import styled from "styled-components";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profileIcon from "../../../assets/User-icon.png"
import { useNavigate, useLocation } from 'react-router-dom';

const MenuBar = styled("div")`
    display: flex;
    width: 100%;
    margin-top: auto;
    margin-left: auto;
    flex-basis: content;
`;

const DropDownContainer = styled("div")`
    padding: 0px 0px 0px 0px;
    cursor: pointer;
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    user-select: none;
    font-size: 12px;
    font-weight: 600;
`;

const DropDownHeader = styled("div")`
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? props.theme.color.dark : 'white'};
    background: transparent;
    border-radius: 5px 5px 0 0;
    padding: 0px 30px 0px 13px;
    background: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'white' : 'transparent'} url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'black' : 'white'}'/></g></svg>") no-repeat;
    background-position: right 10px top 52%;

    &:hover {
        background: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'white' : props.theme.color.primaryhover} url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='12' height='12' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'black' : 'white'}'/></g></svg>") no-repeat;
        background-position: right 10px top 52%;
        color: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? props.theme.color.dark : 'white'};
    }
`;

const MenuHeader = styled("div")`
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? props.theme.color.dark : 'white'};
    background: transparent;
    border-radius: 5px 5px 0 0;
    padding: 0px 13px 0px 13px;
    background: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'white' : 'transparent'} no-repeat;

    &:hover {
        background: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? 'white' : props.theme.color.primaryhover} no-repeat;
        color: ${(props) => (props.isMenuOpened || props.isMenuSelected) ? props.theme.color.dark : 'white'};
    }
`;

const DropDownHeaderProfile = styled("div")`
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px 5px 0 0;
    padding: 0px 13px 0px 13px;
    background: transparent;
    background-position: right 10px top 52%;

    &:hover {
        background: ${(props) => props.theme.color.primaryhover};
    }
`;

const Profile = styled.img`
    width: 16px;
    height: 20px;
    padding-top: 15px;
`;

const DropDownListContainer = styled("div")`
    position: absolute;
`;

const DropDownList = styled("ul")`
    min-width: 150px;
    padding: 10px 0;
    margin: 0;
    background: white;
    box-sizing: border-box;
    color: ${(props) => props.theme.color.gray};
`;

const MenuItem = styled("li")`
    list-style: none;
    line-height: 20px;
    padding: 5px 25px 5px 25px;

    &:hover {
        background: ${(props) => props.theme.color.secondaryhover};
    }
`;

const MenuItemLink = styled(Link)`
    text-decoration: none;
    color: ${(props) => props.theme.color.primaryblue};

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;


function Menu(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const {setLogout, setDatabaseName} = props;
    const [openedMenuId, setOpenedMenuId] = useState(0);
    const [selectedMenuId, setSelectedMenuId] = useState(1);
    
    const showMenu = (menuId) => {
        if (menuId === 0) {
            window.removeEventListener('click', closeAllMenu);
        } else {
        }
        if (openedMenuId !== menuId) {
            window.removeEventListener('click', closeAllMenu);
            setOpenedMenuId(menuId);
        }
        else {
            setOpenedMenuId(0);
        }
    };
    const closeAllMenu = () => {
        if (openedMenuId !== 0) {
            showMenu(0);
        }
    };

    const selectMenuItem = (menuId) => {
        setSelectedMenuId(menuId);
        closeAllMenu();
    }

    const signOut = () => {
        setLogout();
        setDatabaseName('');
    }

    useEffect( ()=> {
        setTimeout(() => {
            if (openedMenuId !== 0) {
                window.addEventListener('click', closeAllMenu);
            }
        }, []);
    });
    
    return <MenuBar>
        <DropDownContainer>
            <MenuHeader onClick={()=>{selectMenuItem(1); navigate('/homepage')}} isMenuOpened={openedMenuId === 1} isMenuSelected={location.pathname.includes('/homepage') && selectedMenuId === 1 && openedMenuId === 0}>HomePage</MenuHeader>
        </DropDownContainer>
        <DropDownContainer>
            <DropDownHeader onClick={()=>{showMenu(2)}} isMenuOpened={openedMenuId === 2} isMenuSelected={location.pathname.includes('/settings/') || selectedMenuId === 2 && openedMenuId === 0}>System settings</DropDownHeader>
            {openedMenuId === 2 && (
            <DropDownListContainer>
                <DropDownList>
                    <MenuItemLink onClick={()=>{selectMenuItem(2)}} to="/settings/branch/main"><MenuItem>Branch / Sub Branch</MenuItem></MenuItemLink>
                    <MenuItemLink onClick={()=>{selectMenuItem(2)}} to="/settings/usersettings/main"><MenuItem>Users & User Rules</MenuItem></MenuItemLink>
                    <MenuItemLink onClick={()=>{selectMenuItem(2)}} to="/settings/system/mainsystem"><MenuItem>Settings</MenuItem></MenuItemLink>
                </DropDownList>
            </DropDownListContainer>
            )}
        </DropDownContainer>
        <DropDownContainer>
            <DropDownHeader onClick={()=>{showMenu(3)}} isMenuOpened={openedMenuId === 3} isMenuSelected={location.pathname.includes('/systemstructure/') || selectedMenuId === 3 && openedMenuId === 0}>System structure</DropDownHeader>
            {openedMenuId === 3 && (
            <DropDownListContainer>
                <DropDownList>
                    <MenuItemLink onClick={()=>{selectMenuItem(3)}} to="/systemstructure/accounttypes"><MenuItem>Account types</MenuItem></MenuItemLink>
                    <MenuItemLink onClick={()=>{selectMenuItem(3)}} to="/systemstructure/accountsections"><MenuItem>Account sections</MenuItem></MenuItemLink>
                    <MenuItemLink onClick={()=>{selectMenuItem(3)}} to="/systemstructure/accountsectioncodes"><MenuItem>Account section codes</MenuItem></MenuItemLink>
                </DropDownList>
            </DropDownListContainer>
            )}
        </DropDownContainer>
        <DropDownContainer>
            <MenuHeader onClick={()=>{if (selectedMenuId !== 4) {selectMenuItem(4); navigate('/generaltables/accountcategories');}}} isMenuOpened={openedMenuId === 4} isMenuSelected={location.pathname.includes('/generaltables') && selectedMenuId === 4 && openedMenuId === 0}>General tables</MenuHeader>
        </DropDownContainer>
        <DropDownContainer>
            <DropDownHeaderProfile onClick={()=>{showMenu(5)}} isMenuOpened={openedMenuId === 1}>
                <Profile src={profileIcon} />
            </DropDownHeaderProfile>
            {openedMenuId === 5 && (
            <DropDownListContainer>
                <DropDownList>
                    <MenuItemLink to="/login" onClick={signOut}><MenuItem>Logout</MenuItem></MenuItemLink>
                </DropDownList>
            </DropDownListContainer>
            )}
        </DropDownContainer>
    </MenuBar>
}

export default Menu;